import { ReactText } from 'react';
import { errorHandler, getErrorCode, StaticErrorCode } from '@myme/utils';
import i18n from 'i18next';
import { customHistory } from 'src/routes/CustomBrowserRouter';
import { somethingWentWrongPageRoute } from 'src/routes/route-list';
import { toast, ToastType } from 'src/utils';

interface Options {
  navigateToErrorPage?: boolean;
  displayCustomToast?: () => ReactText;
  overrideErrorBehavior?: () => void;
}

export const handleError = (err: unknown, options?: Options) => {
  if (options?.overrideErrorBehavior) {
    options.overrideErrorBehavior();
  }

  const error = errorHandler(err);

  if (!options?.displayCustomToast) {
    toast(ToastType.ERROR, i18n.t(`errors.code.${getErrorCode(error) as StaticErrorCode}`));
  }

  if (options?.displayCustomToast) {
    options.displayCustomToast();
  }

  if (options?.navigateToErrorPage) {
    customHistory.push(somethingWentWrongPageRoute);
  }

  return error;
};
